import { siteNav } from "@/mocks/movieData";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200 px-4 md:px-6 pt-12 pb-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">嫂子的诱惑</span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-md">
              本站是围绕《嫂子的诱惑》无删减完整版整理的信息与观影指引页面，集中呈现剧情概览、画质与版本差异、播放线路说明及下载收藏要点，帮助观众快速定位所需内容。
            </p>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-semibold text-foreground-950 mb-4">页面导航</h3>
            <ul className="grid grid-cols-2 gap-2">
              {siteNav.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-sm text-foreground-700 hover:text-primary-600 cursor-pointer transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-foreground-950 mb-4">重要说明</h3>
            <p className="text-sm text-foreground-700 leading-relaxed">
              本页仅提供信息整理，不提供、不托管任何影视资源文件。请通过正规授权渠道观看，尊重并支持正版内容。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-5 border-t border-secondary-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© {year} 嫂子的诱惑 · 观影信息指南页</p>
          <p className="text-xs text-foreground-600">内容仅供参考 · 请支持正版</p>
        </div>
      </div>
    </footer>
  );
}